module.exports = __webpack_public_path__ + "54fbd3af02e4fb9999d8febbaf27baf1.pdf";